export const SuperAdminSidebarData = [
  {
    title: "Dashboard",
    path: "/admin/dashboard",
  },
  {
    title: "Applications",
    subNav: [
      {
        title: "New Applications",
        path: "/new_applications",
      },
      {
        title: "Regional Approvals",
        path: "/regional_approvals",
      },
    ],
  },
  // {
  // 	title: "Polling Station Agents",
  // 	path: "/polling_agents",
  // },
  {
    title: "Operations",
    subNav: [
      {
        title: "Declined Applications",
        path: "/declined_applications",
      },
      {
        title: "Responses",
        path: "/#",
        subNav: [
          {
            title: "Update Response",
            path: "/update_response",
          },
          {
            title: "Activation Response",
            path: "/activation_response",
          },
          {
            title: "Messages Response",
            path: "/messages_response",
          },
        ],
      },
      {
        title: "Regional Reports",
        path: "/regional_report_list",
      },
    ],
  },
  {
    title: "Membership",
    subNav: [
      {
        title: "Global Members",
        path: "/global_members",
      },
      {
        title: "Regional Membership",
        path: "/admin_regional_members",
      },
      {
        title: "Active Members",
        path: "/active_members",
      },
      {
        title: "InActive Members",
        path: "/inactive_members",
      },
    ],
  },
  {
    title: "Card Management",
    subNav: [
      {
        title: "Global Cards",
        path: "/global_cards",
      },
      {
        title: "Pending Cards",
        path: "/pending_cards",
      },
      {
        title: "Pending Confirmation",
        path: "/pending_confirmation",
      },
    ],
  },
  {
    title: "Accounts",
    path: "/#",
    subNav: [
      {
        title: "Receipts",
        path: "/#",
        subNav: [
          {
            title: "Manual Receipt",
            path: "/manual_receipt",
          },
        ],
      },
      {
        title: "Payments",
        path: "/#",
        subNav: [
          {
            title: "Payment Transactions",
            path: "/payment_transactions",
          },
          {
            title: "Payment Clearance",
            path: "/payment_clearance",
          },
          {
            title: "Payment Types",
            path: "/payment_types",
          },
          {
            title: "Yearly Payments",
            path: "/yearly_payments",
          },
        ],
      },
      {
        title: "Ledgers",
        path: "/#",
        subNav: [
          {
            title: "Ledger Accounts",
            path: "/ledger_accounts",
          },
          {
            title: "Yearly Ledgers",
            path: "/yearly_ledgers",
          },
        ],
      },
      {
        title: "Expenditure",
        path: "/#",
        subNav: [
          {
            title: "Expenditure Items",
            path: "/expenditure",
          },
        ],
      },
      {
        title: "Revenue",
        path: "/#",
        subNav: [
          {
            title: "Revenue Items",
            path: "/revenue",
          },
        ],
      },
      {
        title: "Accounts Reports",
        path: "/#",
        subNav: [
          {
            title: "2M2 Payments",
            path: "/2m2_payments",
          },
          {
            title: "Mandatory Payments",
            path: "/mandatory_payments_report",
          },
          {
            title: "Ledger Balances",
            path: "/ledger_balances",
          },
        ],
      },
    ],
  },
  {
    title: "Reports",
    subNav: [
      {
        title: "Membership",
        path: "/#",
        subNav: [
          {
            title: "All Membership",
            path: "/membership_reports",
          },
          {
            title: "Regional Membership",
            path: "/regional_membership_report",
          },
        ],
      },
      {
        title: "Accounts Reports",
        path: "/#",
        subNav: [
          {
            title: "All Payments",
            path: "/payments_reports",
          },
          {
            title: "Mandatory Payments",
            path: "/mandatory_payments_report",
          },
          {
            title: "2M2 Payments",
            path: "/2m2_payments",
          },
          {
            title: "Ledger Balances",
            path: "/ledger_balances",
          },
        ],
      },
    ],
  },
  {
    title: "System Admin",
    subNav: [
      {
        title: "Admin User Management",
        subNav: [
          {
            title: "Admin Users",
            path: "/admin_users",
          },
          {
            title: "Portal Users",
            path: "/portal_users",
          },
          {
            title: "Regional Presidents",
            path: "/regional_presidents",
          },
          {
            title: "Users Online",
            path: "/online_users",
          },
          {
            title: "Admin User Activation",
            path: "/user_activation_management",
          },
          {
            title: "Reset User Password",
            path: "/reset_user_password",
          },
          {
            title: "Create Portal Users",
            path: "/create_portal_users",
          },
        ],
      },
      {
        title: "Duplicate Records",
        path: "/duplicate_records",
      },
      {
        title: "Member Management",
        subNav: [
          {
            title: "Member Activation",
            path: "/activation_management",
          },
          {
            title: "Reset Member Password",
            path: "/reset_member_password",
          },
        ],
      },
      {
        title: "Amendments",
        subNav: [
          {
            title: "Capture Old Members",
            path: "/capture_old_members",
          },
          {
            title: "Change Region",
            path: "/change_region",
          },
          {
            title: "Member Update",
            path: "/find_member",
          },
        ],
      },
      {
        title: "Capture MoMo Payments",
        subNav: [
          {
            title: "New Applicants",
            path: "/new_applicants",
          },
          {
            title: "Existing Members",
            path: "/existing_members",
          },
        ],
      },
      {
        title: "CV Management",
        subNav: [
          {
            title: "Upload Member CV",
            path: "/upload_member_cv",
          },
          {
            title: "View Members CVs",
            path: "/view_cvs",
          },
        ],
      },
      {
        title: "Member Profile Picture",
        path: "/member_profile_picture",
      },
      {
        title: "Roles",
        path: "/roles",
      },
      {
        title: "Yearly Ledgers",
        path: "/#",
        subNav: [
          {
            title: "Create Yearly Payments",
            path: "/yearly_payments",
          },
          {
            title: "Create Yearly Ledgers",
            path: "/yearly_ledgers",
          },
          {
            title: "View Ledger Accounts",
            path: "/ledger_accounts",
          },
          // {
          //   title: "Update Member Ledger",
          //   path: "/update_member_ledger",
          // },
        ],
      },
      {
        title: "General Setup",
        path: "/general_setup",
      },
    ],
  },
  {
    title: "Log Out",
    path: "/admin_logout",
  },
];
